import { request } from '@/api/axios.js';
import { api } from '@/api/index.js';

function saveAs(blob, fileName) {
  const link = document.createElement('a');
  if ('download' in link) {
    link.href = window.URL.createObjectURL(blob);
    link.style.display = 'none';
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    // 对于不支持 download 属性的浏览器（如 IE），使用 window.navigator.msSaveOrOpenBlob 函数
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  }
}

async function cosDownload(url, {isPrivate, onprogress, asyncDownloadBigFile}) {
  let downloadUrl = url;
  if (isPrivate) {
    const res =  await request({
      url:api.getPrivateObjUrl,
      data: {
        app_id: 'nges',
        expires: 300,
        url: url,
      }
    });
    downloadUrl = res?.data?.url;
  }
  return new Promise(async (resolve, reject) => {
    const url2 = downloadUrl.replace(/\\/g, '/');
    // return;
    const xhr = new XMLHttpRequest();
    xhr.open('GET', url2, true);
    xhr.responseType = 'blob';
    // 为了避免大文件影响用户体验，建议加loading
    xhr.onload = () => {
      if (xhr.status === 200) {
        // 获取文件blob数据并保存
        saveAs(new Blob([xhr.response]), name);
        resolve(true);
        return;
      }
      reject(false);
    };
    xhr.onprogress = (progress) => {
      /**
       * 对于大于100m的文件采用window.open打开，避免出现内存溢出问题，当然该url也可能不是文件流，这个时候就会直接打开文件，而不是下载
       * 可以优化大文件下载流程，譬如借助indexdb做断点下载或者server-worker做后台下载，都比较复杂，建议后续有需要建需求完善
       */
      if (asyncDownloadBigFile && progress.total > 100 * 1024 * 1024) {
        xhr.abort();
        window.open(url2);
        return resolve(true);
      }
      onprogress && onprogress(progress);
    };
    xhr.send();
  });
}

export { cosDownload };
